import { useCallback, useEffect, useMemo } from "react";
import { usePaginatedSearch } from "hooks/usePaginatedSearch";
import { getPaginatedCourseData } from "utils/courseService";

export const useCourseSearch = ({ selectedCourse, universityId, pageSize = 20 } = {}) => {
  const fetchPage = useCallback(
    ({ page, size, search }) => getPaginatedCourseData({ page, size, search, universityId }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const { inputValue, setInputValue, debouncedSearch, options, loading, listboxProps } =
    usePaginatedSearch(fetchPage, { pageSize });

  useEffect(() => {
    if (selectedCourse?.courseName && !inputValue) {
      setInputValue(selectedCourse.courseName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCourse?.courseName]);

  const mergedOptions = useMemo(() => {
    if (!selectedCourse?.courseId) return options;
    if (options.some((c) => c.courseId === selectedCourse.courseId)) return options;
    return [selectedCourse, ...options];
  }, [options, selectedCourse]);

  return {
    inputValue,
    setInputValue,
    debouncedSearch,
    options: mergedOptions,
    loading,
    listboxProps,
  };
};
